import styles from './styles.module.scss'
import { SwitcherProps } from './types'

export const Switcher = ({
  label,
  checked,
  onChange,
  disabled,
}: SwitcherProps) => {
  const handleToggle = () => {
    onChange(!checked)
  }

  return (
    <label className={styles.switcher}>
      <input
        type="checkbox"
        name={label}
        onChange={handleToggle}
        checked={checked}
        disabled={disabled}
      />
      <span className={styles.slider}></span>
    </label>
  )
}
